export default __webpack_public_path__ + "static/cl-cs-ipad-a5549bbfadfef9fd6aff65795f740759.png";